var CategoryController = function() {
    this.getScrollScene = require('../module/getScrollScene');
    this.InfiniteScroll = require('../module/InfiniteScroll');
    this.Parallax = require('../module/Parallax');
    this.init();
};

CategoryController.prototype = {
    init: function() {
        //scene controller
        var controller = new ScrollMagic();
        //scene option
        var option = {
            triggerElement: '.category-heading',
            triggerHook: 'onLeave',
            offset: $('.category-heading').height(),
            reverse: true
        };

        var scene = this.getScrollScene(controller, option);

        require('../module/scene-globalHeader')(scene);

        //infiniteScroll & Parallax
        var infiniteScroll = new this.InfiniteScroll();
        var parallax = new this.Parallax();
        var $window = $(window);
        var trigger;

        var scrollHandler = function(){
            if(trigger){
                clearTimeout(trigger);
            }
            trigger = setTimeout(function(){
                if(infiniteScroll.checkPosition()){
                    infiniteScroll.load(parallax.reset.bind(parallax));
                }
            }, 200);
            parallax.scroll();
        }
        var resizeHandler = function(){
            parallax.reset();
            infiniteScroll.resize();
        }
        var loadHandler = function(){
            infiniteScroll.set($('.js-infinite-scroll'));
            parallax.init();
            $window.on('scroll', scrollHandler);
            $window.on('resize', resizeHandler);
        }
        $window.on('load', loadHandler);
    }
};

module.exports = CategoryController;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/controller/CategoryController.js
 **/